import { Injectable } from '@angular/core';
import { LocationItem, LocationItemData, RawLocationNode } from '../models/location-item.model';
import { SelectionType } from '../models/selection-type.enum';

@Injectable()
export class LocationDataHelper {
  fullDataId(dataItem: Pick<LocationItemData, 'type' | 'key'>): string {
    return `${dataItem.type}|${dataItem.key}`;
  }

  createItem(rawNode: RawLocationNode, parent: LocationItem | null = null): LocationItem {
    const { children: rawChildren, ...rest } = rawNode;

    const data: LocationItemData = {
      type: rest.type,
      key: rest.key,
      name: rest.name,
      typeName: rest.typeName ?? rest.type,
      fullName: rest.fullName,
      selectionType: SelectionType.None,
      relevance: rest.relevance
    };

    const item: LocationItem = {
      key: this.fullDataId(rawNode),
      parent,
      isCollapsed: true,
      isActive: false,
      data,
      searchContext: { startIdx: -1, endIdx: -1 }
    };

    if (Array.isArray(rawChildren) && rawChildren.length > 0) {
      item.children = this.createItems(rawChildren, item);
    }

    return item;
  }

  createItems(rawNodes: RawLocationNode[], parent: LocationItem | null = null): LocationItem[] {
    return rawNodes.map(node => this.createItem(node, parent));
  }

  flatten(items: LocationItem[]): LocationItem[] {
    const result: LocationItem[] = [];

    const walk = (nodes: LocationItem[]): void => {
      for (const item of nodes) {
        result.push(item);
        if (item.children) {
          walk(item.children);
        }
      }
    };

    walk(items);
    return result;
  }
}
